import type { AvailabilityException, TemplateWindow } from "@/features/availability/types";

/** Backend serializes Time as "HH:MM:SS"; <input type="time"> uses "HH:MM". */
export function toInputTime(value: string | null | undefined): string {
  if (!value) return "";
  return value.length >= 5 ? value.slice(0, 5) : value;
}

/** Convert an "HH:MM" or "HH:MM:SS" to "HH:MM:SS" for the backend. */
export function toApiTime(value: string): string {
  if (!value) return value;
  return value.length === 5 ? `${value}:00` : value;
}

export function formatTimeRange(start: string, end: string): string {
  return `${toInputTime(start)}–${toInputTime(end)}`;
}

export function templateByDay(template: TemplateWindow[]): TemplateWindow[][] {
  const out: TemplateWindow[][] = [[], [], [], [], [], [], []];
  template.forEach((w) => {
    if (w.day_of_week >= 0 && w.day_of_week <= 6) out[w.day_of_week].push(w);
  });
  out.forEach((arr) => arr.sort((a, b) => a.start_time.localeCompare(b.start_time)));
  return out;
}

export function exceptionsByDate(
  exceptions: AvailabilityException[],
): Map<string, AvailabilityException[]> {
  const map = new Map<string, AvailabilityException[]>();
  exceptions.forEach((e) => {
    const list = map.get(e.date) ?? [];
    list.push(e);
    map.set(e.date, list);
  });
  return map;
}

/** ISO date "YYYY-MM-DD" without timezone shenanigans. */
export function toIsoDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** JS getDay(): 0=Sun..6=Sat. We want 0=Mon..6=Sun. */
export function jsDayToMondayFirst(jsDay: number): number {
  return (jsDay + 6) % 7;
}

/** Validate a single new window doesn't overlap existing windows in the same day. */
export function rangesOverlap(aStart: string, aEnd: string, bStart: string, bEnd: string): boolean {
  return aStart < bEnd && bStart < aEnd;
}
